import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../atoms/Button/Button";
import styles from "./ErrorModal.module.scss";
import { clearNotification } from "../../../redux/actions/actions";
import Modal from "../Modal";
import { testIds } from "../../../common/testData";

const NotificationModal = ({ notificationReducer, clearNotification }) => {
  let { type, messageDisplay } = notificationReducer;
  return (
    <div className={styles["modal-container"]} data-testid={testIds["modal-container"]}>
      {!!type && (
        <Modal
          open={true}
          handleClose={clearNotification}
          minHeight={"336px"}
          width={"520px"}
          zIndex="100000"
        >
          <div>
            <div
              className={`${type === "ERROR"
                ? styles["error-notification"]
                : styles["success-notification"]
                }`}
            >
              <div className={styles["notification-wrapper"]}>
                <div className={styles["icon"]}></div>
                <div className={styles["message"]}>
                  {type === "ERROR" ? "Failed" : "Success"}
                </div>
                <div className={styles["msgDisplay"]}>{messageDisplay}</div>
                <div className={styles["button"]}>
                  <Button
                    variant="notification-Modal-btn"
                    btnText="Okay"
                    onClick={clearNotification}
                  ></Button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  notificationReducer: state.notificationReducer
});

const mapDispatchToProps = (dispatch) => ({
  clearNotification: () => dispatch(clearNotification())
});

NotificationModal.propTypes = {
  notificationReducer: PropTypes.object,
  clearNotification: PropTypes.func
};
export default connect(mapStateToProps, mapDispatchToProps)(NotificationModal);
